import { useQueryClient } from '@tanstack/react-query'

import { ClientError } from '@tribeplatform/gql-client/lib'
import {
  Chat,
  MutationUpdateGroupChatArgs,
} from '@tribeplatform/gql-client/types'

import {
  UseMutationOptions,
  useMutation,
} from '../../lib/react-query/useMutation.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getChatKey, getChatsKey } from '../../utils/keys/messaging.key.js'

export const useUpdateGroupChat = (
  options: UseMutationOptions<Chat, ClientError, MutationUpdateGroupChatArgs>,
) => {
  const { client } = useTribeClient()
  const queryClient = useQueryClient()

  return useMutation<Chat, ClientError, MutationUpdateGroupChatArgs>(
    (input: MutationUpdateGroupChatArgs) =>
      client.messaging.updateGroupChat(input),
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        const chatKey = getChatKey({ variables: { id: variables.chatId } })
        const chatsKey = getChatsKey()
        await queryClient.cancelQueries(chatKey)
        queryClient.setQueriesData<Chat>(chatKey, old => ({
          ...old,
          ...data,
        }))
        queryClient.invalidateQueries(chatsKey)

        if (options.onSuccess) {
          options.onSuccess(data, variables, context)
        }

        return data
      },
    },
  )
}
